import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Wizard from './views/wizard/Wizard.vue'
import store from '@/store.js'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'root'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      beforeEnter (to, from, next) {
        const hasPermission = store.getters['hasPermissionToViewCandidatesList']

        hasPermission
          ? next()
          : next({
            name: 'Wizard'
          })
      }
    },
    {
      path: '/wizard',
      name: 'Wizard',
      component: Wizard
    }
  ]
})
